export default "__VITE_ASSET__eYKx2drp__"